export const BUTTON_SIZE = {
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    FIT_TO_PARENT: 'fit-to-parent',
};
export const BUTTON_TYPE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
    WHITE: 'white',
};
export const BUTTON_CLASS = {
    BUTTON: 'btn_t',
    PRIMARY: 'btn_c_3',
    SECONDARY: 'btn_c_2',
    TERTIARY: 'btn_c',
    WHITE: 'btn_c_4',
};
export const BUTTON_NEW_TYPE = {
    SOLID: 'solid',
    SOLID_PRIMARY: 'solid-primary',
    GRAY: 'gray',
    /** out line */
    OTL: 'otl',
    OTL_PRIMARY: 'otl-primary',
    OTL_GRAY: 'otl-gray',
};
export const BUTTON_NEW_SIZE = {
    SMALL: 'small',
    LARGE: 'large',
};
export const BASIC_BUTTON_SIZE = {
    REGULAR: 'regular',
    SMALL: 'small',
    XSMALL: 'xsmall',
};
export const BASIC_BUTTON_COLOR_TYPE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
};
